module.exports = __webpack_public_path__ + "static/media/cablecircle2.851b39c1.png";